import { deriveMaterial } from 'Pods/ThreeDStudio/Shared/Utils/deriveMaterial'
import { getAssetByTypeAndSource } from 'Pods/ThreeDStudio/Shared/Utils/getAssetByTypeAndSource'
import {
  ACTION,
  PROVIDER,
  TEXTURE_ACTION_TAB,
  VIEWER_SIDEBAR_TAB,
} from 'Pods/ThreeDStudio/Store/constants'

import { getModelFormatOutput } from './getModelFormatOutput'

/**
 * Builds the ThreeDStudio store patch for a Tripo3D retexture-default run.
 * Mirrors parseTencentRetextureProData but derives material directly from
 * enablePbr (Tripo3D retexture only exposes a PBR toggle on the FE form).
 *
 * @param {Object} openedModel - Run object from the library
 * @returns {Object} parsedData - ThreeDStudio store patch
 */
export const parseTripo3dRetextureDefaultData = (openedModel) => {
  const {
    prompt,
    enablePbr,
    modelFormatOutput: rawModelFormatOutput,
    inputAssets,
    outputAssets,
    generatorSessionId,
    id: sessionId,
  } = openedModel
  const enhancedProvider = PROVIDER.TRIPO3D
  const enhancedAction = ACTION.RETEXTURE
  const activeTextureActionTab = prompt ? TEXTURE_ACTION_TAB.TEXT : TEXTURE_ACTION_TAB.IMAGE
  const material = deriveMaterial(enablePbr, false)

  const {
    assetId: inputThreeD,
    fileUrl: inputThreeDUrl,
  } = getAssetByTypeAndSource(outputAssets, '3d_model', 'ai_generated')
  const modelFormatOutput = getModelFormatOutput({
    modelFormatOutput: rawModelFormatOutput,
    modelUrl: inputThreeDUrl,
  })
  const {
    assetId: inputImage,
    fileUrl: inputImageUrl,
  } = getAssetByTypeAndSource(inputAssets, 'image', 'user_upload')

  const schema = { enhancedAction, enhancedProvider }
  const generation = { sessionId, generatorSessionId }
  const viewer = { fileFormat: modelFormatOutput, inputThreeD, material }
  const textureSettings = {
    inputImage,
    inputImageUrl,
    prompt,
    material,
    enablePbr,
  }

  const ui = {
    isModelSettingsOpen: false,
    isViewerSidebarOpen: true,
    activeViewerSidebarTab: VIEWER_SIDEBAR_TAB.TEXTURE,
    activeTextureActionTab,
  }

  return {
    openedModel,
    schema,
    textureSettings,
    ui,
    generation,
    viewer,
  }
}
